<template>
    <div>
        <h3 v-if="title">{{title}}</h3>
        <div class="row">
            <div class="col-12 form-group">
                <span class="float-right">
                    <person-search :person-search-type="personSearchType"
                                   :includeMergedProfiles="false"
                                   @onPersonSelected="onPersonSelected">
                    </person-search>
                </span>
            </div>
            <div class="form-group col-lg-4 col-xl-2 col-md-6">
                <label class="font-weight-bold required" :for="'firstName' + _uid">{{$t('person.firstName') }}</label>
                <input type="text" class="form-control"
                       v-model="person.firstName"
                       v-validate="'required'"
                       :data-vv-as="$t('person.firstName')"
                       :name="'firstName' + _uid"
                       :id="'firstName' + _uid">
                <span class="text-danger" v-if="errors.has('firstName' + _uid)">{{ errors.first('firstName' + _uid) }}</span>
            </div>
            <div class="form-group col-lg-4 col-xl-2 col-md-6">
                <label class="font-weight-bold" :for="'surName' + _uid">{{ $t('person.middleName') }}</label>
                <input type="text" class="form-control" v-model="person.middleName" :id="'surName' + _uid">
            </div>
            <div class="form-group col-lg-4 col-xl-2 col-md-6">
                <label class="font-weight-bold required" :for="'lastName' + _uid">{{ $t('person.lastName') }}</label>
                <input type="text" class="form-control"
                       v-model="person.lastName"
                       v-validate="'required'"
                       :data-vv-as="$t('person.lastName')"
                       :name="'lastName' + _uid"
                       :id="'lastName' + _uid">
                <span class="text-danger" v-if="errors.has('lastName' + _uid)">{{ errors.first('lastName' + _uid) }}</span>
            </div>
            <div class="form-group col-lg-4 col-xl-2 col-md-6">
                <label class="font-weight-bold required" :for="'email' + _uid">{{ $t('email') }}</label>
                <input type="text" class="form-control"
                       v-model="person.email"
                       v-validate="'required|email'"
                       :data-vv-as="$t('email')"
                       :name="'email' + _uid"
                       :id="'email' + _uid">
                <span class="text-danger" v-if="errors.has('email' + _uid)">{{ errors.first('email' + _uid) }}</span>
            </div>
            <div class="form-group col-lg-4 col-xl-2 col-md-6">
                <label class="font-weight-bold" :for="'phone' + _uid">{{ $t('person.phone') }}</label>
                <input type="text" class="form-control" v-model="person.phone" :id="'phone' + _uid">
            </div>
            <div class="form-group col-lg-4 col-xl-2 col-md-6">
                <label class="font-weight-bold" :for="'mobilePhone' + _uid">{{ $t('person.mobilePhone') }}</label>
                <input type="text" class="form-control" v-model="person.mobilePhone" :id="'mobilePhone' + _uid">
            </div>
        </div>
    </div>
</template>

<script>
    import { ContactPerson, Person } from '@/models/models';
    import { PersonSearchType } from "@/models/enums";
    import PersonSearch from "@/components/common/PersonSearch";

    export default {
        inject: ['$validator'],
        components: {
            PersonSearch
        },
        props: {
            person: [Person, ContactPerson],
            title: String
        },
        data() {
            return {
                personSearchType: PersonSearchType.Person
            }
        },
        methods: {
            onPersonSelected(personSearchModel) {
                this.person.firstName = personSearchModel.firstName;
                this.person.middleName = personSearchModel.middleName;
                this.person.lastName = personSearchModel.lastName;
                this.person.email = personSearchModel.email;
                this.person.phone = personSearchModel.phone;
                this.person.mobilePhone = personSearchModel.mobilePhone;
            }
        }
    }
</script>

<style scoped>

</style>
